import { itiMessageService } from '@/iti-core-vue';
import { ItiIconButton, ItiVHeader } from '@/iti-core-vuetify';
import { User } from '@/shared/dtos/user';
import Vue from 'vue';
import userModule from '@/store/modules/user.module'
import { Component } from 'vue-property-decorator';
import UserForm from '@/views/maestros/usuarios/form/user-form.vue';
import EventBusType, { EventBus } from '@/shared/services/event-bus';
import DxDataGrid, { DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';

@Component({
  components: {
    UserForm,
    ItiIconButton,
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxHeaderFilter,
    DxEditing,
    DxColumn,
    DxFilterRow,
    DxFilterPanel,
    DxExport,
    DxColumnChooser
  },
})
export default class UsuersList extends Vue {

  public userSelect: User = new User();

  public get usersList() {
    return userModule.users;
  }

  public pageSize: number = 15;
  public maxWidth: number = 500;
  public addHidden = true;
  public loading = false;
  public search = '';
    
  public get headers() {
      return [        
          new ItiVHeader('id', 'id'),
          new ItiVHeader('completeUser', 'maestro-usuarios.usuario'),
          new ItiVHeader('email', 'maestro-usuarios.email'),
          new ItiVHeader('externalId', 'maestro-usuarios.id-externo'),
          new ItiVHeader('businessName', 'maestro-usuarios.razon-social'),
          new ItiVHeader('province', 'maestro-usuarios.provincia'),
          new ItiVHeader('address', 'maestro-usuarios.direccion'),
          new ItiVHeader('location', 'maestro-usuarios.poblacion'),
          new ItiVHeader('postalCode', 'maestro-usuarios.codigo-postal'),
          new ItiVHeader('country', 'maestro-usuarios.pais'),
          new ItiVHeader('cif', 'maestro-usuarios.cif'),
          new ItiVHeader('cnaeCodeDescription', 'maestro-configuracion.codigo-cnae'),
          new ItiVHeader('associationDescription', 'maestro-configuracion.asociacion'),
          new ItiVHeader('action', ''),
      ];
  }

  public mounted() {
    userModule.getUsers();
  }
  
  public editItem(user: User) {
    this.$router.push({ name: 'EditarUsuarioFormulario', params: { id: user.id.toString() } });
  }

  public formattedContent(contenido: string) {
    if (contenido && contenido.length > 20) {
        return String(contenido).substring(0, 20) + "...";
    } else {
        return contenido;
    }
  }
}